export default "__VITE_ASSET__DxT30QM9__"